import React, { Component } from 'react';
import axios from 'axios';
import './App.css';
import Form from './Form.js';
import Results from './Results';
import Nominees from './Nominees';
import Nav from './Nav';



class App extends Component {

  constructor() {
    super();
    this.state = {
      userInput: "",
      searchResults: [],
      nominees: [],
      nomInfo: [],
      showResults: 'hideR'
    }
  }
  
  apiCall = (key) => {
    axios({
      url: `https://www.omdbapi.com/?type=movie&apikey=a1aad806`,
      method: `GET`,
      responseType: `json`,
      params: {
        s: key,
      }
    }).then((result) => {
      const searchResults = result.data.Search
      this.setState({ searchResults: searchResults })
    })
  }

  loadInput = (e, key) => {
    e.preventDefault();
    this.apiCall(key)
    this.setState({userInput: key})
  }

  apiCall3 = (thing) => {
    axios({
      url: `https://www.omdbapi.com/?type=movie&apikey=a1aad806`,
      method: `GET`,
      responseType: `json`,
      params: {
        i: thing,
      }
    }).then((result) => {
      const nomData = result.data
      this.setState({ nomInfo: [...this.state.nomInfo, nomData] })
    })
  }

  addNom = (e) => {
    const id = e.target.value
    if (this.state.nominees.includes(id)) {
      return alert("Already nominated!")
    }
    else if (this.state.nominees.length >= 5) {
      return alert('Nomination list full, remove one to add more.')
    }
    else{
    this.setState({ nominees: [...this.state.nominees, id]})
    this.apiCall3(id)

    }
  }

  removeNom = (e)=>{
    let nom = e.target.value;
    let nomineesC = [...this.state.nominees];
    let nomInfoC = [...this.state.nomInfo];

    let index = nomineesC.indexOf(nom)
    
    if (index !== -1) {
      nomineesC.splice(index, 1);
      nomInfoC.splice(index, 1);
      this.setState({ nominees: nomineesC,
        nomInfo: nomInfoC
      });
    }
  }

  showResults = () => {
    this.setState({showResults: 'showR'})
    this.scrollInto();
  }



  componentDidMount(){
    const nomsLS = localStorage.getItem('noms')
    const nomInfoLS = JSON.parse(localStorage.getItem('nomInfo'))
    if(nomsLS !== '' && nomsLS != null){
      const nomsLSS = nomsLS.split(',')
      this.setState({
        nominees: nomsLSS,
      })
    }
    if (nomInfoLS) {
      this.setState({
        nomInfo: nomInfoLS,
      })
    }
  }

  componentDidUpdate(){
    localStorage.setItem('noms', this.state.nominees)
    localStorage.setItem('nomInfo', JSON.stringify(this.state.nomInfo))
  }

  inputRef = React.createRef();

  scrollInto = () => {
    this.inputRef.current.scrollIntoView({ behavior: 'smooth' });
  }


  

  render() {
    return (
      <div className="App">
        <Nav count={this.state.nominees}/>
        <Form loadInput={this.loadInput} scroll={this.scrollInto} showResults={this.showResults}/>
        <Results movies={this.state.searchResults} inputRef={this.inputRef} noms={this.state.nominees} addNom={this.addNom} showResults={this.state.showResults}/>
        <Nominees noms={this.state.nomInfo} removeNom ={this.removeNom}/>
      </div>
    );
  }
}
export default App;

